import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class ProjectPlanPhaseEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ProjectPlanPhase";
        this.primaryEnterpriseComponent = "ProjectPlanPhase";

        let eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhase";
        eom.enterpriseComponent = "ProjectPlanPhase";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanAuditLog";
        eom.enterpriseComponent = "ProjectPlanAuditLog";
        eom.relationship = "ProjectPlanProjectPlanAuditLog";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhaseAttachment";
        eom.enterpriseComponent = "ProjectPlanPhaseAttachment";
        eom.relationship = "ProjectPlanPhaseProjectPlanPhaseAttachment";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhaseReference";
        eom.enterpriseComponent = "ProjectPlanPhaseReference";
        eom.relationship = "ProjectPlanPhaseProjectPlanPhaseReference";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhaseApproval";
        eom.enterpriseComponent = "ProjectPlanPhaseApproval";
        eom.relationship = "ProjectPlanPhaseProjectPlanPhaseApproval";
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ProjectPlanPhaseEnterpriseObjectMetadata;